export const usersPageTranslationsPl = {
    usersPage: 'Użytkownicy',
    usersEmail: 'Adres e-mail',
    usersRole: 'Rola',
    usersAddUser: 'Dodaj użytkownika',
    usersDeleteUser: 'Usuń użytkownika',
    usersUpdateUser: 'Edytuj użytkownika',
    usersRemoveConfirmationMessage: 'Czy na pewno chcesz usunąć wybranego użytkownika?',
    usersSendVerificationEmail: 'Wyślij potwierdzenie utworzenia konta na adres email',
};

export const usersPageTranslationsEn = {
    usersPage: 'Users',
    usersEmail: 'E-mail',
    usersRole: 'Role',
    usersAddUser: 'Add user',
    usersDeleteUser: 'Delete user',
    usersUpdateUser: 'Update user',
    usersRemoveConfirmationMessage: 'Are you sure you want to delete the selected user?',
    usersSendVerificationEmail: 'Send account creation confirmation email',
};
